//
//
//
//
//
//
//
//
//
//
//

import vpHeader from '@/components/Header'
import vpFooter from '@/components/Footer'
export default {
  data() {
    return {
      minHeight: 0,
      devicenew:'',
      url: {
        old: '',
        new: ''
      },
      noHeader:false,
    }
  },
  mounted() {
    let { header, footer } = this.$refs
    this.minHeight = document.documentElement.clientHeight - header.$el.offsetHeight - footer.$el.offsetHeight   
//  if(this.$route.query.noHeader && this.$route.query.noHeader=='true'){
//  	this.noHeader=true;
//  }

//  console.log(this.noHeader,'34')
  },
  watch: {
    '$route.name': function(n, o) {      
      this.url.old = n
      this.url.new = o
    },
     $route: function() {
//   	console.log(this.$route,'---40')
//   	debugger
     	if(this.$route.meta && this.$route.meta.noHeader){
     		this.noHeader=true;
     	}
//   	if(this.$route.query.noHeader && this.$route.query.noHeader=='true'){
//  	this.noHeader=true;
//  }
     }
  },
  computed: {
    savePage() {      
      return (this.url.old === 'informationRegister' && !this.url.new) || (this.url.old === 'informationRegisterDetails' && this.url.new === 'informationRegister') || (this.url.old === 'informationRegister' && this.url.new === 'informationRegisterDetails') || (this.url.old === 'UmallBroadbandInformationRegister')
    },
    bg() {
      let { background } = this.$route.meta
      return background || 'white'
    }    
  },
  components: {
    vpHeader,
    vpFooter
  }
}
